const RECEIVE_ALL_VENDOR_CODES = 'src/vendorCodes/RECEIVE_ALL_VENDOR_CODES';
const CLEAR_ALL_VENDOR_CODES = 'src/vendorCodes/CLEAR_ALL_VENDOR_CODES';

export default {
  RECEIVE_ALL_VENDOR_CODES,
  CLEAR_ALL_VENDOR_CODES
};
